module.exports = __webpack_public_path__ + "static/media/BlogThree.a825d2a5.png";